export default {
  qrCodeAccepted: 'QR code accepted',
  confirmed: 'Successfully confirmed!',
}


// WEBPACK FOOTER //
// ./src/utils/success.js